import { Entity, EntityAspect, EntityType } from 'breeze-client';

export class TimeBaseEntity implements Entity {
  entityAspect: EntityAspect;
  entityType: EntityType;

  createdAt: Date;
  createdBy?: string;
  updatedAt: Date;
  updatedBy?: string;
}
